import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { BdaServiceProperty } from "../models/BdaService";

interface InspectorState {
  inspectingItem: any;
}

const initialState: InspectorState = {
  inspectingItem: null,
};

export const inspectorSlice = createSlice({
  name: 'inspector',
  initialState,
  reducers: {
    setInspectingItem(state, action) {
      state.inspectingItem = action.payload;
    },
    updateColumns(state, action) {
      state.inspectingItem.columns = action.payload;
    },
    updateProperties(state, action) {
      state.inspectingItem.properties = action.payload;
    },
    updateProperty(state, action) {
      const newProperty = action.payload;
      const index = state.inspectingItem.properties.findIndex((prop: BdaServiceProperty) => newProperty.id === prop.id);
      const newProperties = [...state.inspectingItem.properties];
      newProperties[index] = newProperty;
      state.inspectingItem.properties = newProperties;
    },
    updateItemLabel(state, action) {
      const label = action.payload;
      state.inspectingItem.label = label;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setInspectingItem, updateColumns, updateProperties, updateProperty, updateItemLabel } = inspectorSlice.actions;

export const inspectingItemTypeSelector = (state: RootState) => (state.inspector.inspectingItem ? state.inspector.inspectingItem.type : null);

export default inspectorSlice.reducer;